module.exports = __webpack_public_path__ + "36c891ef9920b668cde930f9cbf93c5a.svg";